import script from "./SummaryFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryFooter.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryFooter.vue?vue&type=style&index=0&id=3e6d55cf&scoped=true&lang=scss"
import "./SummaryFooter.vue?vue&type=style&index=1&id=3e6d55cf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6d55cf"]])

export default __exports__